import { Formik, Form, Field } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import RadioGroup from "../components/Form/RadioGroup";
import { HAVE_FIDUCIARY } from "./AppealForWho";

export const ADULT = "adult";
export const NOT_ADULT = "not_adult";

export default function AgeCheck() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {

                    const agecheckChanged = values.agecheck !== formData.agecheck;

                    setFormData({
                        ...formData,
                        ...values,
                        ...(agecheckChanged && { 
                            firstname: "",
                            lastname: "",
                            email: "",
                            phone: "",
                            reporterEmail: "",
                        }),
                    });

                    if (values.agecheck === ADULT) {
                        navigate("/vem-overklagar-du-for");
                    } else if (values.agecheck === NOT_ADULT) {
                        navigate("/kontaktuppgifter");
                    }
                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={Yup.object().shape({
                    agecheck: Yup.string().test(
                        "at-least-one-radio-selected",
                        "Frågan “Är du över 18 år” saknar svar ",
                        (value) => {
                            return value === ADULT ||
                                value === NOT_ADULT
                        }
                    ),
                })}
            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-end items-center">
                            <div className="xs:w-52 md:w-full max-w-xs">
                                <Progressbar percentage={"55"} />
                            </div>
                        </div>
                        <Form noValidate>
                            <Box>
                                <h2 ref={h2Ref} tabIndex={-1} id="ageCheckHeading">
                                    Är du över 18 år?
                                </h2>

                                <p>
                                    Om du är under 18 år behöver du ange en mejladress till en vårdnadshavare, god man eller ett ombud.
                                </p>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <RadioGroup name="agecheck" options={[
                                    { id: "adult", value: "adult", label: "Ja, jag är över 18" },
                                    { id: "not_adult", value: "not_adult", label: "Nej, jag är under 18 år" },
                                ]} />

                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>
                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
